/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { ArrowRightCircleFilledIcon, Tag } from "@eds-web/react";
import { CosmosTable as Table, CosmosDate, CosmosLink, CosmosRichText, CosmosText } from "@components/elements";

import { CosmosEnumTimeAndDateFormat, EventsTableRowFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";
import { BoxProps, VisuallyHidden } from "@panda/jsx";

type EventsTableRowProps = EventsTableRowFragment & Omit<BoxProps, "title">;

const eventLinkCell = css({
	display: "flex",
	justifyContent: "center",
	alignSelf: "center",
	padding: "eds.dimension.8",
	borderRadius: "eds.borderRadius.8",
	"&:hover": {
		background: "token(colors.eds.fill.tertiary.hover)",
	},
	"&:has(:focus-visible)": {
		background: "token(colors.eds.fill.tertiary.hover)",
		outline: "token(spacing.eds.dimension.2) solid #fff",
	},
});

export const EventsTableRow = ({
	title,
	badgeLabel,
	location,
	timeAndDate,
	endTimeAndDate,
	timeZone,
	timeAndDateFormat,
	description,
	href,
	...props
}: EventsTableRowProps): React.JSX.Element | null => {
	if (!title) return null;
	return (
		<Table.Row {...props}>
			<Table.Cell display="flex" flexDirection="column" gap="eds.dimension.16">
				<CosmosText variant="headingMD" color="eds.text.primary" text={title} />
				{badgeLabel ? <Tag className={css({ whiteSpace: "nowrap" })} label={badgeLabel} size="sm" /> : ""}
			</Table.Cell>
			<Table.Cell display="flex" flexDirection="column" gap="eds.dimension.8">
				{location ? <CosmosText variant="uiMD" color="eds.text.primary" text={location} /> : ""}
				<CosmosDate
					date={timeAndDate}
					endDate={endTimeAndDate}
					timeAndDateFormat={timeAndDateFormat || CosmosEnumTimeAndDateFormat.WeekdayMonthDayTimeTimeZone}
					timeZone={timeZone}
					className={css({ textStyle: "uiMD", color: "eds.text.primary" })}
				/>
			</Table.Cell>
			<Table.Cell display="flex" flexDirection="row" justifyContent="space-between" gap="eds.dimension.16">
				<CosmosRichText variant="uiMD" color="eds.text.primary" html={description?.html} />
				{href ? (
					<CosmosLink className={eventLinkCell} href={href || ""}>
						<ArrowRightCircleFilledIcon />
						<VisuallyHidden>{title}</VisuallyHidden>
					</CosmosLink>
				) : null}
			</Table.Cell>
		</Table.Row>
	);
};
